import { SmtpConfigurationsComponent, TranslationService } from '@ace/ace';

const PAGE_TITLE_KEY = 'SMTP Configuration';

let patched = false;

/**
 * The SMTP list is the one screen in `@ace` that renders its heading straight
 * from a hardcoded field:
 *
 *   pageTitle = 'SMTP Configuration';        // component
 *   {{ pageTitle }}                          // template
 *
 * It never reaches the translation service, so no dictionary entry can fix it
 * the way it fixes the rest of that page. Everything else there — the columns,
 * the form labels, the buttons, the breadcrumb — already translates.
 *
 * `pageTitle` is a class field, so it is defined on the instance and would
 * shadow an accessor placed on the prototype. Redefining it per instance in
 * `ngOnInit` swaps the plain value for a getter that resolves the key on every
 * change-detection pass, so the heading also follows a language switch.
 *
 * Delete this once the library translates its own page title.
 */
export function patchAceSmtpPageTitle(translation: TranslationService): void {
  if (patched) {
    return;
  }
  patched = true;

  const prototype = SmtpConfigurationsComponent.prototype as { ngOnInit?: () => void };
  const originalNgOnInit = prototype.ngOnInit;

  prototype.ngOnInit = function patchedNgOnInit(this: object): void {
    originalNgOnInit?.call(this);
    Object.defineProperty(this, 'pageTitle', {
      get: () => translation.translate(PAGE_TITLE_KEY),
      configurable: true,
    });
  };
}
